export default {"src":"/_next/static/media/Applied.230b0fc7.svg","height":288,"width":409,"blurWidth":0,"blurHeight":0};